import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrNotificationService } from '../../Common/toastr-notification.service';
import { Evoryn } from '../../Servcie/evoryn';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './login.html',
  styleUrls: ['./login.css']
})
export class Login implements OnInit, OnDestroy {

  currentStep: 'phone' | 'otp' = 'phone';

  phoneForm!: FormGroup;
   phoneNumber: string = '';

  otpArray: string[] = ['', '', '', ''];

  timeLeft: number = 179;
  timerDisplay: string = '02:59';
  timerInterval: any;
   returnUrl: string = '/bank-detail';

  constructor(
    private router: Router,
    private toast: ToastrNotificationService,
    private fb: FormBuilder,
    private api: Evoryn
  ) {
    this.phoneForm = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]]
    });

     const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.phoneNumber = navigation.extras.state['phone'];
      this.phoneForm.patchValue({ phoneNumber: this.phoneNumber });

      if (navigation.extras.state['returnUrl']) {
        this.returnUrl = navigation.extras.state['returnUrl'];
      }
    }
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  requestOtp() {
    if (this.phoneForm.invalid) {
      this.toast.showWarning('Please enter a valid 10-digit mobile number.');
      return;
    }

    const payload = {
      phoneNumber: this.phoneForm.value.phoneNumber
    };

    this.api.partnerlogin(payload).subscribe({
      next: (res: any) => {
        if (res.status && res.data) {
          this.toast.showSuccess(res.message || 'OTP Sent Successfully!');


          sessionStorage.setItem('authOTPID', res.data.authOTPID);
          sessionStorage.setItem('phoneNumber', res.data.phoneNumber);
          sessionStorage.setItem('isValidTill', res.data.isValidTill);
          sessionStorage.setItem('otp', res.data.otp);

          this.currentStep = 'otp';
          this.startTimer();
        } else {
          this.toast.showError(res.message || 'Failed to send OTP.');
        }
      },
      error: (err) => {
        this.toast.showError('Server Error. Please try again later.');
        console.error(err);
      }
    });
  }

  onOtpKeyUp(event: KeyboardEvent, index: number) {
    const key = event.key;

    if (/^[0-9]$/.test(key)) {
      if (index < 3) {
        document.getElementById(`otp-${index + 1}`)?.focus();
      }
    }
  }

  onOtpKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace') {
      if (!this.otpArray[index] && index > 0) {
        this.otpArray[index - 1] = '';
        document.getElementById(`otp-${index - 1}`)?.focus();
      } else {
        this.otpArray[index] = '';
      }
    } else if (event.key === 'ArrowLeft' && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    } else if (event.key === 'ArrowRight' && index < 3) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  }

  startTimer() {
    this.clearTimer();
    this.timeLeft = 179;
    this.updateTimerDisplay();

    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.updateTimerDisplay();
      } else {
        this.clearTimer();
      }
    }, 1000);
  }

  updateTimerDisplay() {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    this.timerDisplay = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  clearTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  resendOtp() {
    if (this.timeLeft > 0) return;
    this.otpArray = ['', '', '', ''];
    this.requestOtp();
  }

  verifyAndLogin() {
    const enteredOtp = this.otpArray.join('');
    if (enteredOtp.length < 4) {
      this.toast.showWarning('Please enter the complete 4-digit OTP.');
      return;
    }

    const authOTPID = sessionStorage.getItem('authOTPID') || 0;

    const payload = {
      authOTPID: Number(authOTPID),
      otp: enteredOtp
    };

    this.api.partnerverifyotp(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toast.showSuccess(res.message || 'Associate Login Successful!');

          if (res.data) {
            sessionStorage.setItem('token', res.data.token || 'mock-token');
            sessionStorage.setItem('userID', res.data.userID || '1');
            
            if (res.isExistingUser === false) {
              this.router.navigate(['/signup'],{
                 state:{
                  phone: this.phoneNumber,
                  returnUrl: this.returnUrl
                }
              }
               
              );
            } else {
              this.router.navigate(['/bank-detail']);
            }
          } else {
            this.router.navigate(['/bank-detail']);
          }
        } else {
          this.toast.showError(res.message || 'Invalid OTP.');
        }
      },
      error: (err) => {
        this.toast.showError('Server Error. Please try again later.');
        console.error(err);
      }
    });
  }
}